<template>
  <EditableFrame
    class="delay-by-sidebar-wrapper"
    title="Edit Action"
    :subtitle="item.name"
    has-save-button
    :save-button-disabled="savedButtonDisabled"
    @close="$emit('close')"
    @save="handleSave"
  >
    <ar-text
      class="delay-by-heading"
      size="13px"
      text="DELAY BY"
      weight="bold"
      multiple-lines
      :max-lines="1"
      letter-spacing="1px"
    />
    <div class="delay-by-wrapper">
      <ar-input
        class="delay-by-input"
        :style="{
          height: '50px',
          width: '163px',
          marginRight: '7px',
        }"
        v-model="delayByVal"
        type="number"
        data-test-id="delay-by-input"
      />
      <ar-simple-select
        class="order-dropdown"
        :items="delayByOptions"
        :default-select-index="dropdownItemIndex"
        :style="{
          height: '50px',
          width: '100%',
          marginBottom: '20px'
        }"
        :dropdown-style="{
          padding: '8px 0',
          maxHeight: '400px',
        }"
        @select="handleDropdownItemSelect"
        data-test-id="delay-by-select"
      />
    </div>
  </EditableFrame>
</template>
<script>
import EditableFrame from '../utils/EditableFrame.vue'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)
export default {
  name: 'DelayBy',
  components: {
    EditableFrame
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      delayByVal: null,
      selectedTimeOption: 'minutes',
      delayByOptions: [
        { name: 'Minute', key: 'minutes'},
        { name: 'Hour', key: 'hours'},
        { name: 'Day', key: 'days'},
        { name: 'Week', key: 'weeks'},
        { name: 'Month', key: 'months'},
      ],
    }
  },
  watch: {
    'item.id'() {
      this.setItemVals()
    }
  },
  computed: {
    dropdownItemIndex() {
      return this.delayByOptions.findIndex(option => option.key === this.selectedTimeOption);
    },
    savedButtonDisabled() {
      return !this.delayByVal
    },
  },
  methods: {
    ...mapActions({
      updateActionConfig: 'automation/UPDATE_ACTION_CONFIG'
    }),
    getDelaySeconds() {
      return dayjs.duration(this.delayByVal, this.selectedTimeOption).asSeconds()
    },
    handleDropdownItemSelect(item) {
      this.selectedTimeOption = item.key
    },
    handleSave() {
      let contextData = {
        config: {
          'delay-sec': this.getDelaySeconds(),
          frontend: {
            delay: {
              val: this.delayByVal,
              selectedKey: this.selectedTimeOption
            }
          }
        },
        meta: {
          delay: {
            val: this.delayByVal,
            selectedKey: this.selectedTimeOption
          }
        }

      }
      this.updateActionConfig({id: this.item.id, data: contextData})
      this.$emit('close')
    },
    setItemVals() {
      if (this.item.config?.['delay-sec']) {
        this.delayByVal = this.item.config.frontend.delay.val
        this.selectedTimeOption = this.item.config.frontend.delay['selected-key'] || this.item.config.frontend.delay['selectedKey']
      }
    }
  },
  mounted() {
    this.setItemVals()
  }
}
</script>
<style lang="scss" scoped>
.delay-by-sidebar-wrapper {
  width: 100%;
  height: 100%;

  .delay-by-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 16px;
  }
}
</style>